import { toast } from 'react-toastify';

import api from '../../services/api';

import {
  CREATE_AUTOMATION_SETTINGS_FAIL,
  CREATE_AUTOMATION_SETTINGS_REQ,
  CREATE_AUTOMATION_SETTINGS_SUCCESS,
  DELETE_AUTOMATION_SETTINGS_FAIL,
  DELETE_AUTOMATION_SETTINGS_REQ,
  DELETE_AUTOMATION_SETTINGS_SUCCESS,
  GET_AUTOMATION_SETTINGS_FAIL,
  GET_AUTOMATION_SETTINGS_REQ,
  GET_AUTOMATION_SETTINGS_SUCCESS,
  UPDATE_ACTIVATE_AUTOMATION_SETTINGS_FAIL,
  UPDATE_ACTIVATE_AUTOMATION_SETTINGS_REQ,
  UPDATE_ACTIVATE_AUTOMATION_SETTINGS_SUCCESS,
  UPDATE_AUTOMATION_SETTINGS_FAIL,
  UPDATE_AUTOMATION_SETTINGS_REQ,
  UPDATE_AUTOMATION_SETTINGS_SUCCESS,
} from '../constants/automation';

let elem = document.getElementById('autometion-create-btn');
console.log(elem);

export const getAllAuromations =
  (curpage, groupFilter = '') =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_AUTOMATION_SETTINGS_REQ });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.get(
        `/api/automation-settings?page=${curpage}&group=${groupFilter}`,
        config
      );

      dispatch({
        type: GET_AUTOMATION_SETTINGS_SUCCESS,
        payload: data?.body,
      });
    } catch (error) {
      dispatch({
        type: GET_AUTOMATION_SETTINGS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === 'NotAuthorized') {
        toast.error('Please login from extension and the reload this page');
        localStorage.removeItem('_gm_usr');
        window.location.reload();
      } else if(error.response.status === 401){
        toast.error("Autorization failed, please re-login to the extension")
      } 
      else {
        toast.error(message);
      }
    }
  };

export const updateAutomationSettings =
  (automationData, automationId = '') =>
  async (dispatch, getState) => {
    try {
      automationId
        ? dispatch({
            type: UPDATE_AUTOMATION_SETTINGS_REQ,
          })
        : dispatch({
            type: CREATE_AUTOMATION_SETTINGS_REQ,
          });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      let url = '';
      url = automationId
        ? `/api/automation-settings?automationId=${automationId}`
        : `/api/automation-settings`;

      const { data } = await api.post(url, automationData, config);

      if (automationId) {
        dispatch({
          type: UPDATE_AUTOMATION_SETTINGS_SUCCESS,
          payload: data?.body,
        });
        // fire event to update automation alarm for the extension

        window.dispatchEvent(
          new CustomEvent('update-automation-settings', {
            bubbles: true,
            detail: {
              userEmail: userInfo.gmUsrEmail,
              automation: data?.body,
            },
          })
        );
        toast.success(data?.msg || 'Automation details updated successfully');
      } else {
        dispatch({
          type: CREATE_AUTOMATION_SETTINGS_SUCCESS,
          payload: data?.body,
        });
        // fire event to create automation alarm for the extension

        window.dispatchEvent(
          new CustomEvent('create-automation-settings', {
            bubbles: true,
            detail: {
              userEmail: userInfo.gmUsrEmail,
              automation: data?.body.automations,
            },
          })
        );
        toast.success(data?.msg || 'Automdation details created successfully');
      }
    } catch (error) {
      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      automationId
        ? dispatch({
            type: UPDATE_AUTOMATION_SETTINGS_FAIL,
          })
        : dispatch({
            type: CREATE_AUTOMATION_SETTINGS_FAIL,
          });

      if (message === 'NotAuthorized') {
        toast.error('Please login from extension and the reload this page');
        localStorage.removeItem('_gm_usr');
        window.location.reload();
      } else if(error.response.status === 401){
        toast.error("Autorization failed, please re-login to the extension")
      } else {
        toast.error(message);
      }
    }
  };

export const updateStatusForAutomationSettings =
  (status, automationId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_ACTIVATE_AUTOMATION_SETTINGS_REQ,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.get(
        `/api/automation-settings/${automationId}/${status}`,
        config
      );

      dispatch({
        type: UPDATE_ACTIVATE_AUTOMATION_SETTINGS_SUCCESS,
        payload: data?.body,
      });

      // fire event to update automation alarm for the extension
      window.dispatchEvent(
        new CustomEvent('update-automation-settings', {
          bubbles: true,
          detail: {
            userEmail: userInfo.gmUsrEmail,
            automation: data?.body,
          },
        })
      );

      toast.success(data.msg);
    } catch (error) {
      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      dispatch({
        type: UPDATE_ACTIVATE_AUTOMATION_SETTINGS_FAIL,
      });

      if (message === 'NotAuthorized') {
        toast.error('Please login from extension and the reload this page');
        localStorage.removeItem('_gm_usr');
        window.location.reload();
      } else if(error.response.status === 401){
        toast.error("Autorization failed, please re-login to the extension")
      } else {
        toast.error(message);
      }
    }
  };

export const deleteAutomation =
  (automationId) => async (dispatch, getState) => {
    try {
      dispatch({ type: DELETE_AUTOMATION_SETTINGS_REQ });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.delete(
        `/api/automation-settings/${automationId}`,
        config
      );

      dispatch({
        type: DELETE_AUTOMATION_SETTINGS_SUCCESS,
        payload: automationId,
      });

      // fire event to delete automation alarm for the extension
      window.dispatchEvent(
        new CustomEvent('delete-automation-settings', {
          bubbles: true,
          detail: {
            userEmail: userInfo.gmUsrEmail,
            automationId: data?.body,
          },
        })
      );

      toast.success('Automation deleted successfully');
    } catch (error) {
      dispatch({
        type: DELETE_AUTOMATION_SETTINGS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === 'NotAuthorized') {
        toast.error('Please login from extension and the reload this page');
        localStorage.removeItem('_gm_usr');
        window.location.reload();
      } else if(error.response.status === 401){
        toast.error("Autorization failed, please re-login to the extension")
      } else {
        toast.error(message);
      }
    }
  };
